const uriParamsWhiteList = ['alias', 'source', 'referer', 'id', 'tt_id'];

export const getSearchParams = (): AnyObject | undefined => {
    const urlParams = new URLSearchParams(window.location.search);
    const tmp = {};
    let params;

    for (const p of uriParamsWhiteList) {
        tmp[p] = urlParams.get(p) || undefined;
    }
    if (Object.keys(tmp).length > 0) {
        params = tmp;
    }

    return params;
};
